export default __webpack_public_path__ + "static/media/pic44.2d62f437.jpg";